module.exports = __webpack_public_path__ + "img/32.e78e998b.svg";